<template>
  <div>
    <page-title
      heading="Manajemen Komisi"
      :breadcrumb="[
        {
          label: 'Manajamen Komisi',
          link: '/komisi',
        },
        {
          label: 'List Komisi',
          active: true,
        },
      ]"
    />
    <div class="container-fluid">
      <div class="card card-box mb-3 ninja-shadow">
        <div class="card-body">
          <div class="col-md-12 no-padding">
            <DataTableWrapper
              :perPage="perPage"
              :fromPage="fromPage"
              :toPage="toPage"
              :totalEntries="totalEntries"
              :currentPage="currentPage"
              :callbackFunc="fetchListKomisi"
              :customEntryOptions="{f: entryOpt}"
              :dropdownSizeProps="'sm'"
              @valueChanged="handleValueChanged"
            >
              <template v-slot:right-header>
                <b-button
                  variant="primary"
                  class="text-uppercase align-self-end"
                  :to="{
                    name: 'klinik-komisi-tambah',
                  }"
                  ><font-awesome-icon icon="plus" />&nbsp;&nbsp;Skema
                  Komisi</b-button
                >
              </template>
              <b-table
                :items="komisiList"
                :fields="fieldList"
                thead-tr-class="izd-datatable"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :no-local-sorting="true"
              >
                <template v-slot:head()="data">
                  {{ data.label }}
                  <b-input
                    size="sm"
                    class="mt-2 w-95"
                    v-if="data.field.searchable"
                    @input="searchValueChanged($event, data.field.key)"
                  />
                </template>
                 <template v-slot:head(kategori)="data">
                  {{ data.label }}
                  <vue-select-clearable
                      id="categoryOpt"
                      style="font-size: 13px"
                      :options="categoryOpt"
                      v-model="categoryId"
                      @input="searchValueChanged($event, data.field.key)"
                      class="custom-v-select-manajemen-tarif mt-2"
                      placeholder="Kategori"
                    >
                      <template slot="option" slot-scope="option">
                        {{ option.label }}
                      </template>
                      <template slot="selected-option" slot-scope="option">
                        {{ option.label }}
                      </template>
                    </vue-select-clearable>
                </template>
                <template v-slot:head(role)="data">
                  {{ data.label }}
                    <vue-select-clearable
                      id="userTypeOpt"
                      style="font-size: 13px"
                      :options="userTypeOpt"
                      v-model="userTypeId"
                      @input="searchValueChanged($event, data.field.key)"
                      class="custom-v-select-manajemen-tarif mt-2"
                      placeholder="Jenis User"
                    >
                    </vue-select-clearable>
                </template>
                <template v-slot:head(type)="data">
                  {{ data.label }}
                  <vue-select-clearable
                      id="comitionTypeOpt"
                      style="font-size: 13px"
                      :options="comitionTypeOpt"
                      v-model="comitionTypeId"
                      @input="searchValueChanged($event, data.field.key)"
                      class="custom-v-select-manajemen-tarif mt-2"
                      placeholder="Tipe Komisi"
                    >
                    </vue-select-clearable>
                </template>
                <template v-slot:cell(actions)="data">
                  <span
                    class="d-flex align-items-center justify-content-between"
                  >
                    <b-dropdown
                      id="dropdown-left"
                      variant="primary"
                      class="m-2"
                      size="sm"
                    >
                      <template #button-content>
                        <font-awesome-icon icon="clone" />
                      </template>
                      <b-dropdown-item 
                        :to="{
                            name: 'klinik-komisi-edit',
                            params: {
                              idComition: data.item.id
                            }
                        }">Ubah</b-dropdown-item>
                      <b-dropdown-item @click="removeKomisi(data.item)"
                        >Hapus</b-dropdown-item
                      >
                    </b-dropdown>
                  </span>
                </template>
              </b-table>
            </DataTableWrapper>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import startCase from "lodash/startCase";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faArrowRight,
  faArrowUp,
  faTrashAlt,
  faSearch,
  faPencilAlt,
  faMoneyBillWave,
  faPlus,
} from "@fortawesome/free-solid-svg-icons";

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import debounce from "lodash/debounce";
import moment from "moment";
import accounting from "accounting";

moment.locale("id");
library.add(
  faArrowRight,
  faMoneyBillWave,
  faArrowUp,
  faTrashAlt,
  faSearch,
  faPencilAlt,
  faPlus
);

export default {
  components: {
    "font-awesome-icon": FontAwesomeIcon,
    DataTableWrapper: () => import("../../components/DataTableWrapper"),
    "vue-select-clearable": () => import("@/components/VueSelectClearable.vue")
  },
  data() {
    return {
      categoryId: '',
      userTypeId: '',
      comitionTypeId: '',
      userTypeOpt: [],
      categoryOpt: [],
      comitionTypeOpt: [
        {
            label: '%',
            value: 'persen',
        },
        {
            label: 'Rp',
            value: 'rupiah',
        }
      ],
      komisiList: [],
      sortBy: "",
      sortDesc: false,
      currentPage: 1,
      rows: 0,
      fromPage: 0,
      toPage: 0,
      perPage: 10,
      searchValue: [],
      totalEntries: 0,
      entryOpt: [5],
    };
  },
  computed: {
    ...mapGetters(["getKlinikId"]),
    fieldList() {
      const { generateFieldList: g, setSearchableAndSortableFieldList: s } =
        this;
      const r = (val) => Boolean(/(no|actions)\b/gi.test(val) ? !1 : 1);
      return (
        [
          {
            key: "kategori",
            label: "Kategori",
            thStyle: "width: 15%",
          },
          {
            key: "nama_layanan",
            label: "nama layanan/obat/bhp",
          },
          {
            key: "role",
            label: "jenis user",
            thStyle: "width: 18%",
          },
          {
            key: "type",
            label: "tipe komisi",
            thStyle: "width: 15%",
          },
          {
            key: "amount",
            label: "nilai komisi",
            thStyle: "width: 15%",
          },
          {
            key: "actions",
            thStyle: "width: 10%",
          },
        ]
        |> ((v) =>
          s({
            field: v,
            customFunc: r,
          }))
        |> ((z) =>
          g({
            field: z,
          }))
      );
    },
  },
  mounted() {
    this.getUserType();
    this.getCategory();
  },
  watch: {
    currentPage() {
      this.fetchListKomisi();
    },
    perPage() {
      this.fetchListKomisi();
    },
    sortBy() {
      this.fetchListKomisi();
    },
    sortDesc() {
      this.fetchListKomisi();
    },
    searchValue: {
      handler: "fetchListKomisi",
      deep: true,
    },
  },
  methods: {
    determineParameter() {
      const { searchValue, sortBy, sortDesc } = this;
      let v = "";
      searchValue.map((item) => {
        const x = item.key;
        v += `&${x}=${item.value}`;
      });
      if (sortBy) {
        v += `&column=${sortBy}&order=${sortDesc ? "desc" : "asc"}`;
      }
      return v;
    },
    handleValueChanged({ perPage, currentPage }) {
      perPage && (perPage |> ((_) => (this.perPage = _)));
      currentPage && (currentPage |> ((_) => (this.currentPage = _)));
    },
    searchValueChanged: debounce(function (val, key) {
      const { searchValue } = this;
      if((['kategori', 'role', 'type']).includes(key)) {
        val = (val == null || val == undefined) ? '' : val.value
      }

      if(key == 'nama_layanan') key = 'layanan';
      if(key == 'kategori') key = 'kategori_id';  
      if(key == 'role') key = 'role_id'; 
      
      const z = searchValue.filter((item) => item.key !== key);
      this.searchValue = [
        ...z,
        {
          key,
          value: val,
        },
      ];
    }, 500),
    detailBayar(id) {
      if (id) {
        this.$router.push({
          name: "pembayaran-tambah",
          params: {
            bayar_id: id,
          },
        });
      }
    },
    viewStruk(id) {
      if (id) {
        this.$router.push({
          name: "pembayaran-struk",
          params: {
            pembayaran_id: id,
          },
        });
      }
    },
    async getCategory() {
        const response = await this.$axios.get(`klinik/list-kategori`)
        this.categoryOpt = response.data.data.map(item => ({
            label: item.nama,
            value: item.id
        }));
    },
    async getUserType() {
        const response = await this.$axios.get(`klinik/list-role`)
        this.userTypeOpt = response.data.data.map(item => ({
            label: item.display_name,
            value: item.id
        }));
    },
    async fetchListKomisi() {
      try {
        const res = await this.$axios.get(
        `klinik/komisi?klinik_id=${this.getKlinikId}&limit=${this.perPage}&page=${
            this.currentPage}${this.determineParameter()}`
        );

        const { status, data } = res.data;
        if (status) {
          const { total } = data;
          const {
            data: tmpData,
            total: totalEntries,
            to: toPage,
            from: fromPage,
            per_page: perPage,
          } = data;

          this.totalEntries = totalEntries || 0;
          this.toPage = toPage || 0;
          this.fromPage = fromPage || 0;
          this.rows = perPage || 0;

          this.komisiList = [
            ...tmpData.map((item, index) => {
              return {
                id: item.id,
                klinik_id: item.klinik_id,
                kategori: item.kategori,
                nama_layanan: item.nama_layanan || "-",
                role: item.role,
                type: item.type == "persen" ? "%" : "Rp",
                amount:
                  item.type == "persen"
                    ? parseFloat(item.amount) + "%"
                    : accounting.formatColumn([item.amount], "Rp. ", 0, ".")[0],
              };
            }),
          ];

          return this;
        }
      } catch (err) {
        // console.log(err);
      }
    },
    async deleteKomisi(id) {
      try {
        const res = await this.$axios.delete(`klinik/komisi/${id}`);
        const { status, data } = res.data;
        this.$swal({
          type: "success",
          text: startCase("Skema Komisi Berhasil Di Hapus"),
        });
        this.fetchListKomisi();
      } catch (err) {
        this.$swal({
          type: "error",
          title: startCase("gagal"),
          text: startCase("komisi gagal di hapus"),
        });
      }
    },
    removeKomisi(item) {
      this.$swal({
        text: `Apakah Anda yakin akan menghapus komisi (${item.kategori} - ${item.nama_layanan} - ${item.role})?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonText: startCase("Ya"),
        confirmButtonColor: "#1791EE",
        cancelButtonText: startCase("Tidak"),
      }).then(async (res) => {
        if (res.value) {
          await this.deleteKomisi(item.id);
        }
      });
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss" scoped>
.multiselect {
  &.__multi-select-tarif {
    min-height: auto !important;
    font-size: 12px !important;
    height: 31px !important;
    & > .multiselect__content-wrapper {
      width: 250px;
    }
    & > .multiselect__select {
      margin-top: -6px;
    }
    & > .multiselect__input {
      font-size: 12px !important;
    }
    & > .multiselect__tags {
      height: 31px !important;
      min-height: 31px !important;
      padding: 2px 30px 0 6px;
    }
  }
  & .multiselect__placeholder, .multiselect__single, .multiselect__input {
    font-size: 8.5pt;
  }
}
</style>
<style lang="css">
    .v-select {
    margin-top: 8px;
    }

    #categoryOpt .vs__dropdown-toggle,
    #comitionTypeOpt .vs__dropdown-toggle,
    #userTypeOpt .vs__dropdown-toggle {
    height: calc(1.5em + 0.5rem + 2px) !important;
    background-color: #ffffff;
    }
</style>
